export default {
  adminNavigation: {
      "dashboard": "数据看板",
      "applications": "应用管理",
      "channelApplications": "渠道应用",
      "homeApplications": "首页应用",
      "customerApplications": "客户应用",
      "customers": "客户管理",
      "customerList": "客户列表",
      "referredCustomers": "专属链接客户",
      "orders": "订单中心",
      "plans": "套餐&算力管理",
      "marketing": "营销管理",
      "marketingMembers": "营销成员",
      "redemptionCodes": "兑换码",
      "companies": "企业管理",
      "companyPlans": "企业套餐",
      "workflows": "工作流管理",
      "labels": "标签管理",
      "categories": "分类管理",
      "agents": "智能体管理",
      "computeRules": "算力规则管理",
      "content": "内容管理",
      "gpuPools": "GPU池管理",
      "tasks": "任务管理",
      "internationalSite": "前往国际版",
      "domesticSite": "前往国内版"
  }
};
